const DEFAULT_ENVIRONMENT = 'Live';

export function getEnvironmentFromUrl(
	routes: Readonly<Record<string, string>> | Readonly<Record<string, string>>[],
	url: string = window.location.href
): string {
	const routeTables = Array.isArray(routes) ? routes : [routes];
	const match = routeTables
		.flatMap((routeTable) => Object.entries(routeTable))
		.find(([, appUrl]) => url.includes(appUrl));

	return match?.[0] ?? DEFAULT_ENVIRONMENT;
}
